import styled from "styled-components";

export const HomeContainerStyled = styled.div`
  .body_container {
    padding: 4px 16px 0 16px;
    .banner_layout {
      margin: 0 -16px;
    }
    .shortcut_layout {
      padding-top: 20px;
    }
    .menu_panel_layout {
      padding: 30px 0px;
    }
    .activity_news_layout {
      margin-bottom: 30px;
      padding-top: 10px;
      padding-left: 16px;
      padding-right: 16px;
    }
    .privilege_layout {
      margin-bottom: 30px;
      padding-left: 16px;
      padding-right: 16px;
    }
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.SURFACE_DUO}) {
    .body_container {
      padding: 0px;
      .banner_layout {
        margin: 0;
      }
      .shortcut_layout {
        padding-top: 30px;
        padding-bottom: 10px;
      }
      .menu_panel_layout {
        padding: 20px 0px 20px 0px;
        background: ${({ theme }) => theme.COLORS.GRAY_6};
      }
      .activity_news_layout {
        padding-top: 20px;
      }
      .privilege_layout {
        margin-bottom: 60px;
      }
    }
  }
`;
